<template>
  <div class="topup-form">
    <div class="topup-form-frame">
      <div class="user-data">
        <h1>{{ $t('view.userData.header') }}</h1>
        <user-data-account />
        <user-data-payment />
      </div>
    </div>
  </div>
</template>

<script>
import UserDataAccount from '@/plus/components/UserData/Account'
import UserDataPayment from '@/plus/components/UserData/Payment'
export default {
  name: 'UserData',
  components: {
    UserDataPayment,
    UserDataAccount
  }
}
</script>

<style src="../assets/scss/user-data.scss" lang="scss"></style>
